import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBSD7YDawvYBsKEUVchpQ1iGLyv_dVSBAU",
  authDomain: "calpackworld.firebaseapp.com",
  projectId: "calpackworld",
  storageBucket: "calpackworld.appspot.com",
  messagingSenderId: "34108327019",
  appId: "1:34108327019:web:1e07f7e63098817f9edd2e",
  measurementId: "G-R9Y8TWTQ9B"
};

const app = initializeApp(firebaseConfig);

export const firestore = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);